import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';
import { invalidateQueryKeys } from 'utils/invalidateQueryKeys';

export const useAddAllTurnaroundsToDelivery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.deliveries.addAllTurnaroundsToDelivery>) =>
      API.deliveries.addAllTurnaroundsToDelivery(...args),
    onSuccess: async () => {
      await invalidateQueryKeys({
        queryClient,
        queryKeys: [
          QueryKeys.Delivery,
          QueryKeys.Deliveries,
          QueryKeys.TurnaroundList,
          QueryKeys.TimeStamps,
          QueryKeys.SurgeryTimeStamps,
        ],
      });
    },
  });
};
